module.exports = __webpack_public_path__ + "fonts/roboto-v20-latin-ext_latin-regular.c5bf51b6.woff2";